import { useState, useCallback } from 'react';
import { notification } from 'tea-component';
import { downloadIEGGFinancialDashboard } from '@sg/services/index';

interface DownloadInfoItem {
  downloadLogKey: string;
  downloadServiceApi: string;
  fileName?: string;
}

interface DownloadInfoMap {
  [key: string]: DownloadInfoItem;
}

/**
 * 下载 hook
 * @param downloadInfoMap - 下载配置映射表，key 为下载类型标识，value 包含 API 路径和日志 key
 * @returns isDownloading - 下载中状态; handleDownload - 下载处理函数
 */
export default function useDownload(downloadInfoMap: DownloadInfoMap) {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = useCallback(
    async (downloadKey: string) => {
      const downloadInfoObj = downloadInfoMap?.[downloadKey];
      if (!downloadInfoObj) {
        notification.error({
          unique: true,
          description: `Invalid download key: ${downloadKey}`,
        });
        return;
      }

      setIsDownloading(true);
      try {
        const res: any = await downloadIEGGFinancialDashboard({}, downloadInfoObj.downloadServiceApi);
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = downloadInfoObj.fileName || 'IEGG_Financials_Dashboard.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch {
        notification.error({
          unique: true,
          description: 'Download failed',
        });
      } finally {
        setIsDownloading(false);
      }
    },
    [downloadInfoMap],
  );

  return {
    handleDownload,
    isDownloading,
  };
}
